import React from "react";
import { DivRibbons } from './style';

import Cera from '../img/Ribbon_Cera.png';
import CeraResina from '../img/Ribbon_CeraResina.png';
import Resina from '../img/Ribbon_Resina.png';

export const Ribbons = () => {

    return (
        <DivRibbons>

            <div className="conteudo">

                <h1>RIBBONS</h1>
                <div className="intro"></div>

                <div className="cards">

                    <div className="card">
                        <h2>Cera</h2>
                        <img src={Cera} alt="ribbon cera" />
                        <p>De valor mais acessível, o seu ponto forte é que pode ser usado na maioria dos substratos
                            (papéis e filmes). Seu ponto fraco é que a etiqueta não pode sofrer muito atrito, podendo
                            borrar e ficar ilegível. Composto com 100% cera.</p>
                    </div>

                    <div className="card">
                        <h2>Cera-resina</h2>
                        <img src={CeraResina} alt="ribbon cera-resina" />
                        <p>Conhecido como "Misto", é composto por uma mistura de Cera e Resina.
                            Seu valor é maior pois possui resina em sua composição, a sua resistência ao atrito é um
                            ponto forte, podendo sofrer atrito e suportar muitas intempéries de transporte.</p>
                    </div>

                    <div className="card">
                        <h2>Resina</h2>
                        <img src={Resina} alt="ribbon resina" />
                        <p>Geralmente usado em filmes (BOPP e OPP, etc), a sua resistência ao atrito e produtos
                            químicos é excelente, entretanto o custo é elevado. Composto com 100% resina.</p>
                    </div>

                </div>

                <div className="linha-final">
                    <span className="quadrado"></span>
                </div>

            </div>

        </DivRibbons>
    )
};
